
import { mixins } from "vue-class-component";
import { DateUtilsMixin } from "@/mixins/date-utils-mixin";
import { Getter, State }  from 'vuex-class';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { IdLookup } from '@/store/validations/types';
import AldProgram, { AldProgramPageState } from '@/components/organs/liver/AldProgram.vue';
import { SystemModules } from '@/store/features/types';
import { Recipient } from '@/store/recipients/types';
import { RecipientJourney } from '@/store/recipientJourney/types';
import CardSection from '@/components/shared/CardSection.vue';

export interface AldProgramForm {
  aldProgram?: AldProgramPageState;
}

@Component({
  components: {
    AldProgram,
    CardSection,
  }
})
export default class AldProgramParticipationDetails extends mixins(DateUtilsMixin) {
  // State
  @State(state => state.pageState.currentPage.aldProgramDetails) editState!: AldProgramForm;
  @State(state => state.recipients.selectedRecipient) recipient!: Recipient;
  @State(state => state.journeyState.selectedJourney) journey!: RecipientJourney;

  // Properties
  @Prop({ default: false }) newJourney!: boolean;
  @Prop({ default: false }) canSave!: boolean;

  @Getter('journeyId', { namespace: 'journeyState' }) journeyId!: string|undefined;
  @Getter('isPaediatricOnJourneyStart', { namespace: 'journeyState' }) isPaediatricOnJourneyStart!: boolean;
  @Getter("moduleEnabled", { namespace: "features" }) private moduleEnabled!: (module: string) => boolean;

  // Comes from card-section after all the lookups are loaded
  public loaded(): void {
    this.initializeForm();
    this.$emit('loaded', 'aldProgramDetails');
  }

  /**
   * Copy relevant data from recipient into the pageState
   */
  public initializeForm(): void {
    // Initialize form edit state
    this.$store.commit('pageState/set', {
      pageKey: 'aldProgramDetails',
      value: { aldProgram: {} }
    });
  }

  // Is the ALD Program Participation system module enabled?
  get isAldProgramParticipationEnabled(): boolean {
    return this.moduleEnabled(SystemModules.ALD_PROGRAM_PARTICIPATION);
  }

  public idLookup(): IdLookup {
    return (this.$refs.aldProgram as AldProgram) ? (this.$refs.aldProgram as AldProgram).idLookup : {};
  }
  // PRIVATE

  // Emit event to parent so it can handle validations
  private handleErrors(errors: any) {
    this.$emit('handleErrors', errors);
  }

  // Emit event to parent so it can handle clearing validations when saving
  private clear() {
    this.$emit('clear');
  }
}
